import { render, staticRenderFns } from "./SafetyStaffList.vue?vue&type=template&id=65d23556&scoped=true&"
import script from "./SafetyStaffList.vue?vue&type=script&lang=js&"
export * from "./SafetyStaffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d23556",
  null
  
)

export default component.exports